import { ProFormSwitch } from '@ant-design/pro-components';
import { withWrap } from '../../utils/hoc';
export default withWrap(ProFormSwitch);
